import { PageLocatorMap } from '../types/PageLocatorMap';

export const previewActivationPage = {
  alert: {
    error: 'preview-activation-page.alert.error',
  },
  footer: {
    root: 'preview-activation-page.footer.root',
  },
  form: {
    emailInput: 'preview-activation-page.form.email-input',
    emailInputError: 'preview-activation-page.form.email-error',
    firstNameInput: 'preview-activation-page.form.first-name-input',
    firstNameInputError: 'preview-activation-page.form.first-name-error',
    h1: 'preview-activation-page.form.heading1',
    h2: 'preview-activation-page.form.heading2',
    lastNameInput: 'preview-activation-page.form.last-name-input',
    lastNameInputError: 'preview-activation-page.form.last-name-error',
    phoneInput: 'preview-activation-page.form.phone-input',
    phoneInputError: 'preview-activation-page.form.phone-error',
    privacyLink: 'preview-activation-page.form.privacy-link',
    root: 'preview-activation-page.form.root',
    submitButton: 'preview-activation-page.form.submit-button',
    termsLink: 'preview-activation-page.form.terms-link',
  },
} as const satisfies PageLocatorMap;
